module.exports = __webpack_public_path__ + "static/media/ProximaNova-SemiboldIt.12fd4b24.woff";